import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

import { useScrollOnRender } from '../../utils/hooks/scroll'

import BarImg from "../../assets/img/bar/bar.png"
import DanceImg from "../../assets/img/bar/dance.jpeg"
import LunchImg from "../../assets/img/bar/lunch.jpeg"
import KaraokeImg from "../../assets/img/bar/karaoke.jpeg"

import localStyle from './About.module.scss'
import { API_HOST, SETTINGS_API_URL } from '../../App'


const fallbackCards = [
    {
        slug: 'bar',
        image: BarImg,
        tag: 'Вечером',
        title: 'Бар',
        text: 'Вас ждет огромное количество разнообразных коктейлей, напитков и блюд по самым доступным ценам в городе',
        url: '/bar',
        button_text: 'Подробнее',
        alt: 'наливаютъ',
    },
    {
        slug: 'dance',
        image: DanceImg,
        tag: 'Ночью',
        title: 'Танцы',
        text: 'Вечеринки каждый день. Лучшие DJ, ведущие и артисты города',
        url: '/dance',
        button_text: 'Подробнее',
        alt: 'танцующие люди',
    },
    {
        slug: 'kitchen',
        image: LunchImg,
        tag: 'Всегда',
        title: 'Кухня',
        text: 'Разнообразное меню кухни по доступным ценам 7 дней в неделю',
        url: '/kitchen',
        button_text: 'Подробнее',
        alt: 'трапеза',
    },
    {
        slug: 'karaoke',
        image: KaraokeImg,
        tag: 'Всегда',
        title: 'Караоке',
        text: 'Стильные и современные залы с широким выбором песен на любой вкус и жанр',
        url: '/karaoke',
        button_text: 'Подробнее',
        alt: 'поющая барышня',
    },
]

export default function AboutCards({
    exclude,
    excludeSlug,
}) {
    useScrollOnRender(true)

    const [cards, setCards] = useState(fallbackCards)

    useEffect(() => {
        let ignore = false

        fetch(SETTINGS_API_URL + '/main_sections').then(
            response => response.json()
        ).then(
            content => {
                if (ignore || !Array.isArray(content) || content.length === 0) return
                setCards(content.map(card => ({
                    ...card,
                    image: card.image ? `${API_HOST}${card.image}` : fallbackCards.find(item => item.slug === card.slug)?.image,
                    alt: card.title,
                })))
            }
        ).catch(
            error => {
                console.error(error)
            }
        )

        return () => {
            ignore = true
        }
    }, [])

    const excludedSlug = useMemo(() => {
        if (excludeSlug) return excludeSlug
        if (typeof exclude === 'number') {
            return fallbackCards[exclude]?.slug
        }
        return undefined
    }, [exclude, excludeSlug])

    const visibleCards = useMemo(
        () => excludedSlug ? cards.filter(card => card.slug !== excludedSlug) : cards,
        [cards, excludedSlug]
    )

    return (
        <section className={localStyle["about"]}>
            <div className={localStyle["cards"] + ' ' + localStyle["inarow"]}>
                {visibleCards.map(card => (
                    <div key={card.slug} className={localStyle["card"]}>
                        <img src={card.image} alt={card.alt}/>
                        <div className={localStyle["chips"]}>{card.tag}</div>
                        <p className={localStyle["tg-authentic"] + ' ' + localStyle["tg-upper"]}>{card.title}</p>
                        <p>{card.text}</p>
                        <Link to={card.url}><p className={localStyle["arrow"]}>{card.button_text || 'Подробнее'}</p></Link>
                    </div>
                ))}
            </div>
        </section>
    )
}
